import { Switch } from '@thanx/uikit/switch'
import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import { ContentBlockTypes } from 'api/landingPageTheme'
import brameImage from 'assets/images/cms/app-home-page/brame.svg'
import useDispatch from 'hooks/useDispatch'
import { buildTranslate } from 'locales'
import React from 'react'
import { push } from 'react-router-redux'
import { ContentBlockData } from 'slices/appLandingPageTheme/types'
import ConfigurationInfo from './ConfigurationInfo'

const t = buildTranslate('cms.content.app_home_page.content.block_item')

type Props = {
  type: ContentBlockTypes
  data?: ContentBlockData
  isDisabled?: boolean
  size?: 'small' | 'medium'
  unavailable?: boolean
}

const Description = ({
  type,
  data,
  isDisabled,
  size = 'medium',
  unavailable = false,
}: Props) => {
  const [css] = useStyletron()
  const dispatch = useDispatch()
  const description = t(`${type}.description`)
  const opacity = isDisabled ? '50%' : '100%'
  const fontSize = size ? '14px' : '16px'

  return (
    <div className="d-flex flex-column">
      <div className={css({ opacity })}>
        <Text.BodyText3
          color="grey70"
          className={css({ fontSize: fontSize, overflowWrap: 'anywhere' })}
        >
          {description}
        </Text.BodyText3>
        <Switch condition={unavailable}>
          <Text.BodyText3
            color="grey70"
            className={`mt-s ${css({
              fontSize: fontSize,
              overflowWrap: 'anywhere',
            })}`}
          >
            {t(`${type}.unavailable`)}
          </Text.BodyText3>
        </Switch>
      </div>
      <Switch condition={type === 'game' && unavailable}>
        <div className={`mt-s ${css({ marginBottom: '8px' })}`}>
          <button
            type="button"
            className="btn btn-link p-0"
            onClick={() => dispatch(push('/games'))}
          >
            {t(`${type}.learn_more`)}
          </button>
        </div>
      </Switch>
      <Switch condition={type === 'game'}>
        <div
          className={`d-flex align-items-center mt-s ${css({
            gap: '4px',
            opacity,
          })}`}
        >
          <Text.BodyText3
            color="grey70"
            className={css({ fontSize: fontSize })}
          >
            {t(`${type}.powered_by`)}
          </Text.BodyText3>
          <img
            src={brameImage}
            alt="BRAME"
            className={css({ height: '14px', width: '60px' })}
          />
        </div>
      </Switch>
      {data && <ConfigurationInfo contentBlock={data} />}
    </div>
  )
}

export default Description
